import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from 'store/modules/temporary'
import { localized } from 'decorators'
import { Page } from 'components/page'
import { versions } from 'release-notes-list'

const VersionItem = ({ version, items }) => {
  return (
    <div>
      <label>{version}</label>
      <ul>
        {items.map((x, idx) => <li key={idx}>{x}</li>)}
      </ul>
    </div>
  )
}

const ReleaseNotesListPage = ({ localize }) => {
  return (
    <Page
      title={localize('releaseNotes.title')}
      metadata={{}}
      hideGoBack
      canCreate={false}
      canGoToTrash={false}
      localize={localize}>
        <React.Fragment>
          {versions.map((x, idx) => <VersionItem key={idx} {...x} />)}
        </React.Fragment>
      
    </Page>
  )
}

export default connect(
  ({ temporary }) => ({ temporary }),
  { deleteAllBottles: actionCreators.deleteAllBottles }
)(localized(ReleaseNotesListPage))
